import { connect } from 'react-redux';
import { isEmpty as _isEmpty } from 'lodash-es';
import { withRouter, Route } from 'react-router-dom';
import LoginRedirect from '../LoginRedirect';
import NotFound from 'components/route/NotFound';
import PropTypes from 'prop-types';
import React from 'react';
import Util from 'utilities';

const StaffOrSponsorRoute = ({
  component: TheComponent,
  isSponsor,
  isLoggedIn,
  isStaff,
  render,
  userIdentified,
  ...props
}) => {
  return (
    <Route
      {...props}
      render={props => {
        if (!isLoggedIn) return <LoginRedirect {...props} />;
        if (!isStaff && !isSponsor) return <NotFound {...props} />;
        return render ? render(props) : <TheComponent {...props} />;
      }}
    />
  );
};

const mapStateToProps = state => ({
  isSponsor: Util.isSponsor(state),
  isLoggedIn: Util.isLoggedIn(state),
  isStaff: Util.isStaff(state),
  userIdentified: !_isEmpty(state?.auth?.me)
});

StaffOrSponsorRoute.contextTypes = {
  component: PropTypes.object
};

export default withRouter(
  connect(
    mapStateToProps,
  )(StaffOrSponsorRoute)
);
